"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rememberWeAreRedirectingToEpicLogin = rememberWeAreRedirectingToEpicLogin;
exports.recallIfWeRedirectedToEpicLoginAndCompleteLoginIfSo = recallIfWeRedirectedToEpicLoginAndCompleteLoginIfSo;

var _auth = require("../redux/modules/auth");

var _reactRouter = require("react-router");

var _utils = require("./utils");

var _sanitizeUrl = require("@braintree/sanitize-url");

var _config = require("../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var localStorageKey = "epicLoginRedirectTo";

var epicLoginUrl = _config2.default.epicSSOBaseUrl + "/login/index?client_id=" + _config2.default.epicClientID + "&response_type=code";
var epicRegisterUrl = _config2.default.epicSSOBaseUrl + "/register/index?client_id=" + _config2.default.epicClientID + "&response_type=code";

function rememberWeAreRedirectingToEpicLogin(location, redirectTo) {
  return function () {
    var pathname = location.pathname;

    if (pathname === "/login") {
      var query = location.query;
      var returnTo = query.returnTo,
          return_to = query.return_to;


      if (returnTo || return_to) {
        localStorage.setItem(localStorageKey, returnTo || return_to);
      } else {
        localStorage.setItem(localStorageKey, "/");
      }
    } else {
      localStorage.setItem(localStorageKey, pathname);
    }
    if (redirectTo == "login") {
      window.location = (0, _sanitizeUrl.sanitizeUrl)(epicLoginUrl);
    }
    if (redirectTo == "register") {
      window.location = (0, _sanitizeUrl.sanitizeUrl)(epicLoginUrl);
    }
  };
}

function recallIfWeRedirectedToEpicLoginAndCompleteLoginIfSo(location) {
  return function (dispatch, getState) {
    var code = location && location.query && location.query.code || null;
    var epicLoginRedirectTo = localStorage.getItem(localStorageKey);
    localStorage.removeItem(localStorageKey);

    if (code && epicLoginRedirectTo) {
      dispatch((0, _auth.epicLogin)(code)).then(function (res) {
        if (res.isUnlinkedAccount === true) {
          _reactRouter.browserHistory.push({
            pathname: "/link-epic-account",
            search: "?returnTo=" + epicLoginRedirectTo
          });
        } else {
          var newState = getState();
          var user = newState.user;
          var subscription = user.subscription;

          var doesntAlreadyHaveUnrealUnlimited = !subscription || !subscription.planId === "unreal-unlimited";

          if (user.isUnrealEULAAccepted && doesntAlreadyHaveUnrealUnlimited) {
            _reactRouter.browserHistory.replace({
              pathname: "/epic-migration",
              search: "?returnTo=" + epicLoginRedirectTo
            });
          } else {
            if (epicLoginRedirectTo === "/epic-migration") {
              _reactRouter.browserHistory.replace(epicLoginRedirectTo, {
                state: { hideSwitchingPlans: true }
              });
            } else {
              if ((0, _utils.isForumLink)(epicLoginRedirectTo)) {
                // handling if its external forum link
                _reactRouter.browserHistory.push({
                  pathname: "/login",
                  search: "?return_to=" + epicLoginRedirectTo
                });
              } else if (epicLoginRedirectTo.indexOf("/megascans/") > -1) {
                window.location = (0, _sanitizeUrl.sanitizeUrl)(epicLoginRedirectTo);
              } else {
                _reactRouter.browserHistory.replace(epicLoginRedirectTo);
              }
            }
          }
        }
      }).catch(function (err) {
        // TODO development log only
        console.log("error logging in", err);
        // handle error
      });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/actions.js
// module id = 1275
// module chunks = 0